export default __webpack_public_path__ + "assets/footer-grove-dark.as-path.68446168.svg";